import { render, staticRenderFns } from "./QuestionUploadVueComponent.vue?vue&type=template&id=a57affa2&scoped=true&"
import script from "./QuestionUploadVueComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionUploadVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionUploadVueComponent.vue?vue&type=style&index=0&id=a57affa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57affa2",
  null
  
)

export default component.exports